export default __webpack_public_path__ + "static/media/ep1-poster-from-spaceship.7fe0d5eb.jpg";